import {
  CLEAR_ERRORS,
  CLEAR_ERRORS_BY_TYPE,
  CLEAR_PERSISTENT_ERRORS,
  ERROR,
  PERSISTENT_ERROR,
  SET_ITEMS_TYPE
} from "../constants";

import {
  clearErrors,
  clearErrorsByType,
  clearPersistentErrors,
  error,
  setItemsType,
  persistentError
} from "./payloadCreators";

export default {
  [CLEAR_ERRORS]: clearErrors,
  [CLEAR_ERRORS_BY_TYPE]: clearErrorsByType,
  [CLEAR_PERSISTENT_ERRORS]: clearPersistentErrors,
  [ERROR]: error,
  [PERSISTENT_ERROR]: persistentError,
  [SET_ITEMS_TYPE]: setItemsType
};
